export class TimesheetCoworkerProject {
    public id: number;
    public name: string;
    public hours: string;
    public coworker: { id: number; name: string };
    public timeInterval: number;
}
